module.exports = __webpack_public_path__ + "img/add_meeting_hover.07ec11b1.svg";